export const documentFields = {
    DOCUMENT_CREATION_DATE: 'document_creation_date',
    DOCUMENT_VALIDITY_DATE: 'document_validity_date',
    DOCUMENT_TYPE: 'document_type_id',
    FILE_SYNC: 'file_sync',
    FILE_DESCRIPTION: 'file_description',
    DOCUMENT_PROPERTY_INTERNAL_APP_ID: 'document_property_internalAppId',
    DOCUMENT_PROJECT_INTERNAL_APP_ID: 'document_project_internalAppId',
    DOCUMENT_CONTACT_ID: 'document_contact_id',
    DOCUMENT_CONTACT_INTERNAL_APP_ID: 'document_contact_internalAppId',
}

export const documentDetailSearchFields = {
    FILE_DESCRIPTION: 'fileDescription',
    DOCUMENT_TYPE: 'documentTypeId',
    DOCUMENT_PROPERTY_ID: 'documentPropertyInternalAppId',
    DOCUMENT_PROJECT_ID: 'documentProjectInternalAppId',
    DOCUMENT_CONTACT_ID: 'documentContactId',
    DOCUMENT_CREATION_DATE_FROM: 'documentCreationDateFrom',
    DOCUMENT_CREATION_DATE_TO: 'documentCreationDateTo',
    DOCUMENT_VALIDITY_DATE_FROM: 'documentValidityDateFrom',
    DOCUMENT_VALIDITY_DATE_TO: 'documentValidityDateTo',
}


